import React from 'react'

import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import moment from "moment";

import SubComponentCard from './SubComponent';

export default function ReadingAttribution({ attribution, tl, dir, componentCommentsCount }) {
	return (
		<>
			<SubComponentCard title="Attribution" id="attribution" commentsCount={componentCommentsCount("attribution")}>
				<Paper elevation={0} square className="p-16">
					<Grid container spacing={1}>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Title (TL):
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className={`${tl} m-0`} dir={dir}>
									{attribution.title_tl}
								</Typography>
							</Grid>		
						</Grid>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Title (EN):
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{attribution.title_en}
								</Typography>
							</Grid>															
						</Grid>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Source URL:
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{attribution.source_url}
								</Typography>
							</Grid>									
						</Grid>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Author:
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{attribution.author}
								</Typography>
							</Grid>				
						</Grid>
						{attribution.author_desc_tl && (
							<Grid item container xs={12} spacing={1}>
								<Grid item xs={12} sm={4} lg={2}>
									<Typography className="text-14 font-semibold m-0">
										Author Description (TL):
									</Typography>
								</Grid>
								<Grid item xs={12} sm={8} lg={10}>
									<Typography className={`${tl} m-0`} dir={dir}>
										{attribution.author_desc_tl}
									</Typography>
								</Grid>
							</Grid>
						)}
						{attribution.author_desc_en && (
							<Grid item container xs={12} spacing={1}>
								<Grid item xs={12} sm={4} lg={2}>
									<Typography className="text-14 font-semibold m-0">
										Author Description (EN):
									</Typography>
								</Grid>
								<Grid item xs={12} sm={8} lg={10}>
									<Typography className="text-14 m-0">
										{attribution.author_desc_en}
									</Typography>
								</Grid>
							</Grid>
						)}
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Published Date:
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{moment.utc(attribution.published_date).local().format('MMM DD, YYYY')}
								</Typography>
							</Grid>						
						</Grid>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Downloaded Date:
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{moment.utc(attribution.downloaded_date).local().format('MMM DD, YYYY')}
								</Typography>
							</Grid>						
						</Grid>
						<Grid item container xs={12} spacing={1}>
							<Grid item xs={12} sm={4} lg={2}>
								<Typography className="text-14 font-semibold m-0">
									Copyright License:
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} lg={10}>
								<Typography className="text-14 m-0">
									{attribution.cc_license}
								</Typography>
							</Grid>								
						</Grid>
					</Grid>
				</Paper>
			</SubComponentCard>
			<SubComponentCard title="Content" id="content" commentsCount={componentCommentsCount("content")}>
				<Paper elevation={0} square className="p-16">
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<Typography className={`${tl} m-0 wysiwyg`} dir={dir} dangerouslySetInnerHTML={{ __html: attribution.display_content }} />
						</Grid>	
					</Grid>
				</Paper>
			</SubComponentCard>
		</>
	);
}
